import { PERMISSIONS } from '@app/permissions/permissions';
import {
    BOOKING_ROUTE,
    DATASHEETS_DASHBOARD_ROUTE,
    DEFECTS_ROUTE,
    EXECUTION_DASHBOARD_ROUTE,
    MODULES_ROUTE,
    PERFORMANCE_DASHBOARD_ROUTE,
    PROFILE_ROUTE,
    SCHEME_EDIT_ROUTE,
    SCHEME_ROUTE,
    SCHEME_SCRATCH_ROUTE,
    SCHEMES_FAVORITES_ROUTE,
    SCHEMES_ROUTE,
    TESTCASE_HISTORY_ROUTE,
    TESTCASE_ROUTE,
    TESTCASES_ROUTE,
    TESTPLAN_HISTORY_ROUTE,
    TESTPLAN_ROUTE,
    TESTPLANS_ROUTE,
    TESTRESULT_AUTO_ROUTE,
    TESTRESULT_HAND_ROUTE,
    TESTRUN_ROUTE,
    TESTRUNS_ROUTE,
} from '@shared/constants/routesConstants';

export type RoutePermissionMap = Record<string, PERMISSIONS>;

export const INITIAL_ROUTE_PERMISSION_MAP: RoutePermissionMap = {
    [EXECUTION_DASHBOARD_ROUTE]: PERMISSIONS.VIEW_DASHBOARDS,
    [PERFORMANCE_DASHBOARD_ROUTE]: PERMISSIONS.VIEW_DASHBOARDS,
    [DATASHEETS_DASHBOARD_ROUTE]: PERMISSIONS.VIEW_DASHBOARDS,
    [MODULES_ROUTE]: PERMISSIONS.VIEW_MODULES,
    [TESTCASES_ROUTE]: PERMISSIONS.VIEW_TESTCASES,
    [TESTPLANS_ROUTE]: PERMISSIONS.VIEW_TESTPLANS,
    [TESTRUNS_ROUTE]: PERMISSIONS.VIEW_TESTRUNS,
    [SCHEMES_ROUTE]: PERMISSIONS.VIEW_SCHEMES,
    [SCHEMES_FAVORITES_ROUTE]: PERMISSIONS.VIEW_SCHEMES,
    [SCHEME_SCRATCH_ROUTE]: PERMISSIONS.VIEW_SCHEMES,
    [PROFILE_ROUTE]: PERMISSIONS.VIEW_PROFILES,
    [BOOKING_ROUTE]: PERMISSIONS.VIEW_BOOKINGS,
    [DEFECTS_ROUTE]: PERMISSIONS.VIEW_DEFECTS,
};

const DYNAMIC_ROUTE_PERMISSION_MAP: RoutePermissionMap = {
    [TESTCASE_ROUTE]: PERMISSIONS.VIEW_TESTCASES,
    [TESTCASE_HISTORY_ROUTE]: PERMISSIONS.VIEW_TESTCASES,
    [TESTPLAN_ROUTE]: PERMISSIONS.VIEW_TESTPLANS,
    [TESTPLAN_HISTORY_ROUTE]: PERMISSIONS.VIEW_TESTPLANS,
    [TESTRUN_ROUTE]: PERMISSIONS.VIEW_TESTRUNS,
    [TESTRESULT_AUTO_ROUTE]: PERMISSIONS.VIEW_TESTRUNS,
    [TESTRESULT_HAND_ROUTE]: PERMISSIONS.VIEW_TESTRUNS,
    [SCHEME_ROUTE]: PERMISSIONS.VIEW_SCHEMES,
    [SCHEME_EDIT_ROUTE]: PERMISSIONS.VIEW_SCHEMES,
};

export const ROUTE_PERMISSION_MAP: RoutePermissionMap = {
    ...INITIAL_ROUTE_PERMISSION_MAP,
    ...DYNAMIC_ROUTE_PERMISSION_MAP,
};
